import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { PatientCalendarSync } from "@/components/account/patient-calendar-sync";

export const Route = createFileRoute("/_authenticated/account/user/settings/calendar")({
  component: PatientCalendarSettingsPage,
});

function PatientCalendarSettingsPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>Calendar sync</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>
            Connect Google, Outlook, or Apple Calendar so appointments land directly in your
            personal calendar.
          </Trans>
        </p>
      </header>
      <PatientCalendarSync />
    </div>
  );
}
